import NoResultsTable from "views/Components/Shared/Components/NoResultsTable";

export const tableStyles = {
  borderTop: "1px solid #E0E0E0",
  "& .MuiDataGrid-main": {
    borderLeft: "none",
    borderRight: "none",
    paddingBottom: "16px !important",
  },
  "& .MuiDataGrid-columnHeader": {
    borderLeft: "none",
    borderRight: "none",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #E0E0E0",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    cursor: "pointer",
  },
  "& .MuiDataGrid-row": {
    borderBottom: "none",
  },
  "& .MuiDataGrid-columnHeaders": {
    cursor: "default",
  },
  "& .border-right": {
    borderRight: "1px solid #E0E0E0",
  },
  "& .border-bottom": {
    borderBottom: "1px solid #E0E0E0",
  },
  "& .MuiDataGrid-columnHeader--emptyGroup": {
    borderBottom: "1px solid #E0E0E0",
  },
  "& .header": {
    backgroundColor: "#f3f4f6",
  },
  "& .MuiDataGrid-columnHeader--checkboxSelection": {
    backgroundColor: "#f3f4f6 !important",
  },
  "& .MuiDataGrid-columnHeaderCheckbox": {
    backgroundColor: "#f3f4f6 !important",
  },
  "& .MuiDataGrid-pinnedColumnHeaders .MuiDataGrid-columnHeader--checkboxSelection":
    {
      backgroundColor: "#f3f4f6 !important",
    },
  "& .MuiDataGrid-row.Mui-selected": {
    backgroundColor: "#0028780A",
  },
  "& .MuiDataGrid-checkboxInput": {
    color: "#002878 !important",
  },
  "& .header-special": {
    backgroundColor: "#e2e8f0",
  },
  "& .cell-special": {
    backgroundColor: "#f1f5f9",
  },
  "& .editable": {
    color: "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiDataGrid-overlayWrapper": {
    minHeight: "180px",
  },
  "& .MuiDataGrid-overlayWrapperInner": {
    minHeight: "180px",
  },
  "& .no-padding": {
    padding: "0 !important",
  },
  "& .cell-cat": {
    backgroundColor: "#FFE0B2 !important",
  },
  "& .cell-hij": {
    backgroundColor: "#f9cfcf !important",
  },
  "& .triangle-top-left-cat": {
    width: "0",
    height: "0",
    borderBottom: "16px solid transparent",
    borderLeft: "16px solid orange",
  },
  "& .triangle-top-left-error": {
    width: "0",
    height: "0",
    borderBottom: "16px solid transparent",
    borderLeft: "16px solid red",
  },
  "& .triangle-bottom-left-error": {
    width: "0",
    height: "0",
    borderTop: "16px solid transparent",
    borderLeft: "16px solid red",
  },
  "& .MuiToolbar-root": {
    padding: "0 !important",
  },
  "& .MuiDataGrid-main": {
    paddingBottom: "16px !important",
  },
  height: "calc(100vh - 218px)",
};

export const slots = {
  noRowsOverlay: () => (
    <NoResultsTable
      message="No hay tickets en el backlog"
      message2="Cuando se ingresen devoluciones desde la sección 'Reception', aparecerán aquí para gestionar y asignar a un técnico."
      buttonText="Ir a ingreso de devoluciones"
      buttonLink="/service-operation/ingresar"
    />
  ),
  noResultsOverlay: () => (
    <NoResultsTable
      message="No se encontraron resultados"
      message2="Intenta ajustar tus filtros de búsqueda."
      buttonText="Ir a ingreso de devoluciones"
      buttonLink="/service-operation/ingresar"
    />
  ),
};
